import React from 'react';
import { TouchableOpacity } from 'react-native';

import GameVisualizerIcon from '@/assets/icons/gameVisualizer';
import { designSystem } from '@/styles/styles';
import { FloatingModalConfig, useFloatingModal } from '@/utils/floatingModal/FloatingModalProvider';

export const GameTrackerButton = ({
    config,
    sideEffectOnPress,
    iconColor,
    iconSize,
}: {
    config: FloatingModalConfig;
    sideEffectOnPress?: () => Promise<void>;
    iconColor?: string;
    iconSize?: number;
}) => {
    const { openModal } = useFloatingModal();

    return (
        <TouchableOpacity
            hitSlop={12}
            onPress={() => {
                openModal(config);
                sideEffectOnPress?.();
            }}
        >
            <GameVisualizerIcon
                color={iconColor ?? designSystem.colors.neutral300}
                width={iconSize}
                height={iconSize}
            />
        </TouchableOpacity>
    );
};
